import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  container: {
    maxWidth: '450px',
    '& div': {
      maxWidth: '450px',
    },
    '& span': {
      maxWidth: '450px',
      wordBreak: 'break-all',
    },
  },
});
